import { FaHammer, FaRulerCombined, FaTree, FaPaintBrush } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaHammer />, // Hammer icon
    title: 'Custom Woodwork',
    description: 'Offering bespoke woodwork solutions crafted to perfection',
  },
  {
    id: 2,
    icon: <FaRulerCombined />, // Ruler Combined icon
    title: 'Precision Craftsmanship',
    description: 'Providing meticulous attention to detail for flawless results',
  },
  {
    id: 3,
    icon: <FaTree />, // Tree icon
    title: 'Natural Materials',
    description: 'Using high-quality, sustainably sourced wood for timeless beauty',
  },
  {
    id: 4,
    icon: <FaPaintBrush />, // Paint Brush icon
    title: 'Customization Options',
    description: 'Offering a wide range of finishes and styles to suit your preferences',
  },
];

export default features;